<template>
  <div class="no-bind">
    <!-- H5 登录区域：宽度 < 600px 时由媒体查询展示 -->
    <div class="no-bind-h5 h5content column">
      <div class="h5-login-wrap">
        <!-- 顶部 Logo -->
        <img class="h5-login-logo" :src="logoImg" alt="蓝莓象" />

        <!-- 提示文案 -->
        <div class="h5-login-tips">
          <div>首次使用，请先登录蓝莓象的账号进行登录，</div>
          <div>只需登录一次，后续会自动登录。</div>
        </div>

        <!-- 登录方式切换 -->
        <div class="h5-tab-switch row">
          <template v-for="(btn, index) in loginBtnArr" :key="index">
            <div
              v-if="showUserSignIn && btn === 'user'"
              class="h5-tab-item flex-1"
              :class="{ active: activeName === 'user' }"
              @click="changeType('user')"
            >
              账号登录
            </div>
            <div
              v-if="showPhoneSignIn && btn === 'phone'"
              class="h5-tab-item flex-1"
              :class="{ active: activeName === 'phone' }"
              @click="changeType('phone')"
            >
              手机号登录
            </div>
          </template>
        </div>

        <!-- 表单区域：固定高度，切换时按钮位置不变 -->
        <div class="h5-login-panel">
          <div class="h5-login-form-body">
            <!-- 账号登录表单 -->
            <el-form
              v-show="activeName === 'user'"
              ref="accountFormRef"
              class="h5-login-form"
              :model="accountForm"
              label-width="0"
              @keyup.enter="handleLoginSubmit"
            >
              <el-form-item class="h5-form-item-wrap">
                <div class="h5-form-row row">
                  <label class="h5-form-label"
                    >账号<span class="h5-required">*</span></label
                  >
                  <el-input
                    v-model="accountForm.username"
                    class="h5-form-input"
                    placeholder="请输入账号"
                    maxlength="50"
                    auto-complete="off"
                  />
                </div>
              </el-form-item>

              <el-form-item class="h5-form-item-wrap">
                <div class="h5-form-row row">
                  <label class="h5-form-label"
                    >密码<span class="h5-required">*</span></label
                  >
                  <el-input
                    v-model="accountForm.password"
                    class="h5-form-input"
                    :type="passwordType"
                    placeholder="请输入密码"
                    maxlength="20"
                    auto-complete="off"
                  >
                    <template #suffix>
                      <el-icon
                        class="h5-password-icon"
                        @click="togglePasswordVisible"
                      >
                        <View v-if="passwordType === 'text'" />
                        <Hide v-else />
                      </el-icon>
                    </template>
                  </el-input>
                </div>
              </el-form-item>

              <el-form-item class="h5-form-item-wrap">
                <div class="h5-form-row row">
                  <label class="h5-form-label"
                    >验证码<span class="h5-required">*</span></label
                  >
                  <el-input
                    v-model="accountForm.code"
                    class="h5-form-input flex-1"
                    placeholder="请输入验证码"
                    maxlength="6"
                    auto-complete="off"
                  />
                  <img
                    class="h5-captcha-img"
                    :src="accountForm.captchaImage"
                    alt="验证码"
                    @click="refreshCaptcha"
                  />
                </div>
              </el-form-item>
            </el-form>

            <!-- 手机号登录表单 -->
            <el-form
              v-show="activeName === 'phone'"
              ref="phoneFormRef"
              class="h5-login-form"
              :model="phoneForm"
              label-width="0"
              @keyup.enter="handleLoginSubmit"
            >
              <el-form-item class="h5-form-item-wrap">
                <div class="h5-form-row row">
                  <label class="h5-form-label"
                    >手机号<span class="h5-required">*</span></label
                  >
                  <el-input
                    v-model="phoneForm.phone"
                    class="h5-form-input"
                    placeholder="请输入手机号"
                    maxlength="11"
                    auto-complete="off"
                    @input="handlePhoneInput"
                  />
                </div>
              </el-form-item>

              <el-form-item class="h5-form-item-wrap">
                <div class="h5-form-row row">
                  <label class="h5-form-label"
                    >验证码<span class="h5-required">*</span></label
                  >
                  <el-input
                    v-model="phoneForm.code"
                    class="h5-form-input flex-1"
                    placeholder="请输入验证码"
                    maxlength="6"
                    auto-complete="off"
                  />
                  <button
                    type="button"
                    class="h5-send-code-btn"
                    :disabled="smsCountdown > 0 || smsSending"
                    @click="handleSendSmsCode"
                  >
                    {{ smsBtnText }}
                  </button>
                </div>
              </el-form-item>
            </el-form>
          </div>

          <el-button
            type="primary"
            class="h5-login-submit"
            @click.prevent="handleLoginSubmit"
          >
            立即登录
          </el-button>
        </div>
      </div>
    </div>

    <!-- PC 登录区域：宽度 ≥ 600px 时由媒体查询展示 -->
    <div class="pc-login-page">
      <!-- 顶部品牌 Logo -->

      <!-- 主视觉背景区，登录卡片居中偏右展示 -->
      <div class="pc-login-main">
        <div
          class="pc-login-banner"
          :style="{ backgroundImage: `url(${pcbgImg})` }"
        >
          <img class="pc-login-logo" :src="lifeilogoImg" alt="蓝莓象" />
          <div class="pc-login-tips">首次使用，请先登录蓝莓象的账号进行登录，只需登录一次，后续会自动登录。</div>
          <div class="pc-login-card">
            <h4 class="pc-login-title">登录蓝莓象系统</h4>

            <!-- 登录方式切换 -->
            <div class="topTabSelect row flex-center">
              <template v-for="(btn, index) in loginBtnArr" :key="index">
                <div
                  v-if="showUserSignIn && btn === 'user'"
                  class="flex-1"
                  :class="{ active: activeName === 'user' }"
                  @click="changeType('user')"
                >
                  <span>账号登录</span>
                </div>
                <div
                  v-if="showPhoneSignIn && btn === 'phone'"
                  class="flex-1"
                  :class="{ active: activeName === 'phone' }"
                  @click="changeType('phone')"
                >
                  <span>手机号登录</span>
                </div>
              </template>
            </div>

            <!-- 表单区域：固定高度，切换时按钮位置不变 -->
            <div class="pc-login-form-panel">
              <div class="pc-login-form-body">
                <!-- 账号登录表单 -->
                <div v-show="activeName === 'user'" class="userlogin">
                  <el-form
                    ref="accountFormRef"
                    class="login-form clear-el-col"
                    :model="accountForm"
                    label-width="0"
                    @keyup.enter="handleLoginSubmit"
                  >
                    <el-form-item>
                      <el-input
                        v-model="accountForm.username"
                        :size="'large'"
                        placeholder="请输入账号"
                        maxlength="50"
                        auto-complete="off"
                        @keyup.enter="handleAccountLogin"
                      >
                        <template #prefix>
                          <i class="iconfont icon-icon_user"></i>
                        </template>
                      </el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-input
                        v-model="accountForm.password"
                        :size="'large'"
                        :type="passwordType"
                        placeholder="请输入密码"
                        maxlength="20"
                        auto-complete="off"
                        @keyup.enter="handleAccountLogin"
                      >
                        <template #prefix>
                          <i class="iconfont icon-lock"></i>
                        </template>
                        <template #suffix>
                          <el-icon
                            class="el-input__icon"
                            @click="togglePasswordVisible"
                          >
                            <View v-if="passwordType === 'text'" />
                            <Hide v-else />
                          </el-icon>
                        </template>
                      </el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-row :gutter="10">
                        <el-col :span="16">
                          <el-input
                            v-model="accountForm.code"
                            :size="'large'"
                            placeholder="请输入验证码"
                            maxlength="6"
                            auto-complete="off"
                            @keyup.enter="handleAccountLogin"
                          >
                            <template #prefix>
                              <i class="iconfont icon-security"></i>
                            </template>
                          </el-input>
                        </el-col>
                        <el-col :span="8">
                          <div class="login-code">
                            <img
                              class="login-code-img"
                              :src="accountForm.captchaImage"
                              alt="验证码"
                              @click="refreshCaptcha"
                            />
                          </div>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-form>
                </div>

                <!-- 手机号登录表单 -->
                <el-form
                  v-show="activeName === 'phone'"
                  ref="phoneFormRef"
                  class="login-form"
                  :model="phoneForm"
                  label-width="0"
                  @keyup.enter="handleLoginSubmit"
                >
                  <el-form-item>
                    <el-input
                      v-model="phoneForm.phone"
                      :size="'large'"
                      placeholder="请输入手机号"
                      maxlength="11"
                      auto-complete="off"
                      @keyup.enter="handlePhoneLogin"
                      @input="handlePhoneInput"
                    >
                      <template #prefix>
                        <i class="iconfont icon-iconfontcall-copy"></i>
                      </template>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <div class="row">
                      <el-input
                        v-model="phoneForm.code"
                        :size="'large'"
                        placeholder="请输入验证码"
                        maxlength="6"
                        auto-complete="off"
                        @keyup.enter="handlePhoneLogin"
                      >
                        <template #prefix>
                          <i class="iconfont icon-security"></i>
                        </template>
                      </el-input>
                      <el-button
                        class="send-code-btn"
                        :disabled="smsCountdown > 0 || smsSending"
                        @click="handleSendSmsCode"
                      >
                        {{ smsBtnText }}
                      </el-button>
                    </div>
                  </el-form-item>
                </el-form>
              </div>

              <el-button
                type="primary"
                class="login-submit"
                @click.prevent="handleLoginSubmit"
              >
                立即登录
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { View, Hide } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import md5 from "js-md5";
import {
  getCaptcha,
  getPhoneCode,
  loginByUsername,
  loginByPhone,
  getMiniProgramAppId,
  bindCurrentWecom,
  bindWecomRpa,
} from "@/api/base.js";
import { userStore } from "@/store/user.js";
import { navStore } from "@/store/nav.js";
import { getStore, setStore } from "@/util/store.js";
import func from "@/util/func.js";
import { isJuzi } from "@/util/platform.js";
import { isMobile } from "@/util/validate.js";
import pcbgImg from "@/assets/pc/img/home/banner.png";
import lifeilogoImg from "@/assets/pc/img/home/lifeilogo.png";
import logoImg from "@/assets/pc/img/home/logo.png";

// 短信验证码倒计时时长（秒）
const SMS_COUNTDOWN_SECONDS = 120;

// 密码最短长度
const MIN_PASSWORD_LENGTH = 6;

// 短信验证码位数
const SMS_CODE_LENGTH = 6;

//默认租户填写
const DEFAULT_TENANT_ID = "950601";

// 验证码占位图（加载前显示）
const CAPTCHA_PLACEHOLDER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

export default {
  name: "nobind",
  components: {
    View,
    Hide,
  },
  data() {
    return {
      pcbgImg,
      lifeilogoImg,
      logoImg,
      // 当前登录方式：user-账号登录，phone-手机号登录
      activeName: "user",
      // 登录 Tab 顺序
      loginBtnArr: ["user", "phone"],
      showUserSignIn: true,
      showPhoneSignIn: true,
      passwordType: "password",
      // 账号登录表单
      accountForm: {
        username: "",
        password: "",
        code: "",
        captchaKey: "",
        captchaImage: CAPTCHA_PLACEHOLDER,
      },
      // 手机号登录表单
      phoneForm: {
        phone: "",
        code: "",
        smsToken: "",
      },
      // 短信倒计时
      smsCountdown: 0,
      smsSending: false,
      smsTimer: null,
    };
  },
  computed: {
    // 获取验证码按钮文案
    smsBtnText() {
      if (this.smsCountdown > 0) {
        return `${this.smsCountdown}s后重试`;
      }
      return "获取验证码";
    },
  },
  mounted() {
    // 非橘子平台使用企微用户信息预填账号和手机号，减少首次登录输入
    this.fillDefaultLoginInfo();
    // PC / H5 共用验证码初始化（展示由 CSS 媒体查询控制）
    this.refreshCaptcha();
  },
  beforeUnmount() {
    this.clearSmsTimer();
  },
  methods: {
    /**
     * 进入页面时，根据当前平台的企微用户字段预填登录表单
     */
    fillDefaultLoginInfo() {
      const qwUserInfo = getStore({ name: "qwUserInfo" }) || {};
      // 橘子平台姓名字段为 name，其他平台为 userName
      this.accountForm.username = isJuzi()
        ? qwUserInfo.name || ""
        : qwUserInfo.userName || "";
      this.phoneForm.phone = !isJuzi()?qwUserInfo.mobile:"";
    },

    /**
     * 切换登录方式
     */
    changeType(loginType) {
      this.activeName = loginType;
    },

    /**
     * 切换密码明文/密文显示
     */
    togglePasswordVisible() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },

    /**
     * 刷新图形验证码
     */
    refreshCaptcha() {
      getCaptcha()
        .then((res) => {
          const captchaData = res.data?.data || res.data || {};
          this.accountForm.captchaKey = captchaData.key || "";
          this.accountForm.captchaImage =
            captchaData.image || CAPTCHA_PLACEHOLDER;
        })
        .catch(() => {
          ElMessage.error("验证码获取失败，请稍后重试");
        });
    },

    /**
     * 限制手机号仅输入数字
     */
    handlePhoneInput(value) {
      this.phoneForm.phone = String(value || "").replace(/[^\d]/g, "");
    },

    /**
     * 账号登录提交前校验，失败用提示展示
     * @returns {boolean}
     */
    validateAccountForm() {
      const { username, password, code } = this.accountForm;
      if (!String(username || "").trim()) {
        ElMessage.warning("请输入账号");
        return false;
      }
      if (!String(password || "").trim()) {
        ElMessage.warning("请输入密码");
        return false;
      }
      if (String(password).length < MIN_PASSWORD_LENGTH) {
        ElMessage.warning(`密码长度最少为${MIN_PASSWORD_LENGTH}位`);
        return false;
      }
      if (!String(code || "").trim()) {
        ElMessage.warning("请输入验证码");
        return false;
      }
      return true;
    },

    /**
     * 手机号登录提交前校验，失败用提示展示
     * @returns {boolean}
     */
    validatePhoneForm() {
      const { phone, code, smsToken } = this.phoneForm;
      if (!String(phone || "").trim()) {
        ElMessage.warning("请输入手机号");
        return false;
      }
      if (!isMobile(phone)) {
        ElMessage.warning("请输入正确的手机号");
        return false;
      }
      if (!String(code || "").trim()) {
        ElMessage.warning("请输入验证码");
        return false;
      }
      if (String(code).length !== SMS_CODE_LENGTH) {
        ElMessage.warning(`请输入${SMS_CODE_LENGTH}位验证码`);
        return false;
      }
      if (!smsToken) {
        ElMessage.warning("请先获取验证码");
        return false;
      }
      return true;
    },

    /**
     * 发送短信前仅校验手机号
     * @returns {boolean}
     */
    validatePhoneForSms() {
      const phoneValue = String(this.phoneForm.phone || "").trim();
      if (!phoneValue) {
        ElMessage.warning("请输入手机号");
        return false;
      }
      if (!isMobile(phoneValue)) {
        ElMessage.warning("请输入正确的手机号");
        return false;
      }
      return true;
    },

    /**
     * 发送手机短信验证码
     */
    handleSendSmsCode() {
      if (!this.validatePhoneForSms()) {
        return;
      }
      if (this.smsCountdown > 0 || this.smsSending) {
        return;
      }

      this.smsSending = true;
      getPhoneCode({
        phone: this.phoneForm.phone,
        tenantId: this.getLoginTenantId(),
        type: 1,
      })
        .then((res) => {
          // smsToken 直接取 res.data.data
          this.phoneForm.smsToken = res.data?.data || "";
          ElMessage.success("验证码已发送");
          this.startSmsCountdown();
        })
        .catch(() => {
          ElMessage.error("验证码发送失败，请稍后重试");
        })
        .finally(() => {
          this.smsSending = false;
        });
    },

    /**
     * 启动短信倒计时
     */
    startSmsCountdown() {
      this.clearSmsTimer();
      this.smsCountdown = SMS_COUNTDOWN_SECONDS;
      this.smsTimer = setInterval(() => {
        if (this.smsCountdown <= 1) {
          this.smsCountdown = 0;
          this.clearSmsTimer();
          return;
        }
        this.smsCountdown -= 1;
      }, 1000);
    },

    /**
     * 清除短信倒计时定时器
     */
    clearSmsTimer() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
    },

    /**
     * 登录用 tenantId：优先 localStorage，其次 userStore，最后默认值
     */
    getLoginTenantId() {
      const user = userStore();
      return (
        getStore({ name: "tenantId" }) || user.tenantId || DEFAULT_TENANT_ID
      );
    },

    /**
     * 统一登录提交（根据当前 Tab 分发）
     */
    handleLoginSubmit() {
      if (this.activeName === "user") {
        this.handleAccountLogin();
        return;
      }
      this.handlePhoneLogin();
    },

    /**
     * 账号登录：密码 md5 后调用 loginByUsername
     */
    handleAccountLogin() {
      if (!this.validateAccountForm()) {
        return;
      }
      loginByUsername(
        this.getLoginTenantId(),
        this.accountForm.username,
        md5(this.accountForm.password),
        "account",
        this.accountForm.captchaKey,
        this.accountForm.code,
      )
        .then((res) => {
          this.handleLoginSuccess(res);
        })
        .catch((err) => {
          
          this.refreshCaptcha();
        });
    },

    /**
     * 手机号登录：调用 loginByPhone
     */
    handlePhoneLogin() {
      if (!this.validatePhoneForm()) {
        return;
      }
      loginByPhone(
        this.getLoginTenantId(),
        this.phoneForm.phone,
        this.phoneForm.code,
        this.phoneForm.smsToken,
      )
        .then((res) => {
          this.handleLoginSuccess(res);
        })
        .catch((err) => {
         
        });
    },

    /**
     * 登录成功：先绑定企微，绑定成功后再落库 Token / 用户信息并回跳
     * @param {Object} res - 登录接口响应
     */
    handleLoginSuccess(res) {
      // OAuth 返回体通常在 res.data；偶发包一层 data 时做兼容
      const loginData = res.data?.access_token ? res.data : res.data?.data;
      if (!loginData) {
        ElMessage.error("登录返回数据异常");
        return;
      }

      const { access_token, refresh_token } = loginData;
      if (func.isEmpty(access_token)) {
        ElMessage.error("登录失败，未获取到 Token");
        return;
      }

      // 绑定请求通过请求头携带新 token，成功后再写入 store
      this.bindWecomAfterLogin(access_token)
        .then(() => {
          const user = userStore();
          user.setUserInfo(loginData);
          user.setToken(access_token);
          user.setRefreshToken(refresh_token);

          // 橘子平台：Token 落库后再拉小程序 AppId（失败不阻断跳转）
          if (isJuzi()) {
            this.fetchJuziMiniProgramAppId(user);
          }

          const redirectPath = navStore().firstOpenPath || "/";
          this.$router.replace(redirectPath);
        })
        .catch((err) => {
      
        });
    },

    /**
     * 橘子平台拉取并缓存小程序 AppId
     * @param {Object} user - userStore 实例
     */
    fetchJuziMiniProgramAppId(user) {
      getMiniProgramAppId()
        .then((appIdRes) => {
          const { appId, appOriginalId } = appIdRes?.data?.data || {};
          if (!func.isEmpty(appId)) {
            user.wxAppId = appId;
            setStore({
              name: "wxAppId",
              content: appId,
            });
            user.miniprogramOriginId = appOriginalId;
            setStore({
              name: "miniprogramOriginId",
              content: appOriginalId,
            });
          }
        })
        .catch((err) => {
        
        });
    },

    /**
     * 登录成功后与当前企微用户绑定（请求头携带新 access_token，尚未写入 store）
     * 橘子平台走 bindWecomRpa，其余走 bindCurrentWecom
     * @param {string} accessToken - 登录返回的 access_token
     * @returns {Promise}
     */
    bindWecomAfterLogin(accessToken) {
      const qwUserInfo = getStore({ name: "qwUserInfo" }) || {};

      if (isJuzi()) {
        return bindWecomRpa(
          {
            email: qwUserInfo.email || "",
            name: qwUserInfo.name || "",
            orgId: qwUserInfo.orgId || "",
            uid: qwUserInfo.uid || "",
          },
          accessToken,
        );
      }

      return bindCurrentWecom(
        {
          wecomUserId: qwUserInfo.id || "",
        },
        accessToken,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.no-bind {
  width: 100%;
  min-height: 100vh;
}

/* 默认展示 H5；宽度 ≥ 600px 时隐藏 */
.no-bind-h5 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 0.667rem 0.333rem 0.5rem;
  background-color: #fff;
  box-sizing: border-box;
}

@media (min-width: 600px) {
  .no-bind-h5 {
    display: none;
  }
}

/* H5 登录容器：居中，最大宽度 750px */
.h5-login-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  height: 760px;
}

.h5-login-logo {
  display: block;
  width: 2.667rem;
  height: auto;
  margin: 0.333rem auto 0rem;
}

.h5-login-tips {
  line-height: 1.5;
}

.h5-login-tip {
  margin-bottom: 0.667rem;
  color: #666;
  font-size: 0.292rem;
  line-height: 1.6;
  text-align: center;

  p {
    margin: 0;
  }
}

/* H5 Tab 切换：描边胶囊样式 */
.h5-tab-switch {
  width: 100%;
  margin-bottom: 0.5rem;
  border: 1px solid #28b8c3;
  border-radius: 0.125rem;
  overflow: hidden;
  margin-top: 0.5rem;
}

.h5-tab-item {
  height: 0.75rem;
  color: #28b8c3;
  font-size: 0.292rem;
  line-height: 0.75rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &.active {
    color: #fff;
    background-color: #28b8c3;
  }
}

/* H5 表单面板：固定填写区高度，按钮固定在底部 */
.h5-login-panel {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
}

.h5-login-form-body {
  height: 4.167rem;
}

/* H5 表单 */
.h5-login-form {
  width: 100%;

  :deep(.h5-form-item-wrap) {
    margin-bottom: 0;
    padding: 0;
  }

  :deep(.el-form-item__content) {
    width: 100%;
    margin-left: 0 !important;
  }

  :deep(.el-form-item__error) {
    padding-top: 0.083rem;
    font-size: 0.25rem;
    text-align: right;
  }
}

.h5-form-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.292rem 0;
  border-bottom: 1px solid #f0f0f0;
  gap: 0.167rem;
}

.h5-form-label {
  flex-shrink: 0;
  width: 1.4rem;
  color: #333;
  font-size: 0.292rem;
  line-height: 1.4;
}

.h5-required {
  margin-left: 0.042rem;
  color: #f56c6c;
}

.h5-form-input {
  flex: 1;

  :deep(.el-input__wrapper) {
    padding: 0;
    border: none;
    border-radius: 0;
    box-shadow: none !important;
    background-color: transparent;
  }

  :deep(.el-input__inner) {
    color: #333;
    font-size: 0.292rem;
    text-align: left;
  }
}

.h5-password-icon {
  color: #909399;
  font-size: 0.333rem;
  cursor: pointer;
}

.h5-captcha-img {
  flex-shrink: 0;
  width: 1.667rem;
  height: 0.583rem;
  border: 1px solid #f0f0f0;
  border-radius: 0.042rem;
  background-color: #fdfdfd;
  cursor: pointer;
}

.h5-send-code-btn {
  flex-shrink: 0;
  min-width: 1.667rem;
  height: 0.583rem;
  padding: 0 0.125rem;
  border: 1px solid #28b8c3;
  border-radius: 0.042rem;
  background-color: #fff;
  color: #28b8c3;
  font-size: 0.25rem;
  line-height: 0.583rem;
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    border-color: #dcdfe6;
    background-color: #f5f7fa;
    color: #c0c4cc;
    cursor: not-allowed;
  }
}

.h5-login-submit {
  flex-shrink: 0;
  width: 100%;
  height: 0.917rem;
  margin-top: 1rem;
  border: none;
  border-radius: 0.125rem;
  background-color: #28b8c3;
  font-size: 0.333rem;
  letter-spacing: 0.083rem;

  &:hover,
  &:focus {
    background-color: #24a8b2;
  }
}

/* PC 登录页：默认隐藏，宽度 ≥ 600px 时展示 */
.pc-login-page {
  display: none;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding: 32px 48px 48px;
  box-sizing: border-box;
  background-color: #f5f8f9;
}

@media (min-width: 600px) {
  .pc-login-page {
    display: flex;
  }
}

.pc-login-logo {
  display: block;
  width: 168px;
  height: auto;
  margin-bottom: 24px;
  position: absolute;
  top: -110px;
  left: 10px;
}

.pc-login-tips {
  color: #666;
  font-size: 0.292rem;
  line-height: 1.6;
  text-align: center;
  position: absolute;
  top: -40px;
  left: 15px;
  background-color: #e8f8fd;
  padding: 4px 10px;
  border-radius: 5px;
  text-align: center;
}


.pc-login-main {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.pc-login-banner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 1080px;
  max-width: 1080px;
  min-width: 1080px;
  min-height: 550px;
  border-radius: 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  box-sizing: border-box;
}

/* 登录卡片 */
.pc-login-card {
  display: flex;
  flex-direction: column;
  color: #fff;
  width: 400px;
  height: 485px;
  position: absolute;
  right: 42px;
  top: 36px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 30px 40px 30px 40px;
}

/* PC 表单面板：固定填写区高度，按钮置底 */
.pc-login-form-panel {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.pc-login-form-body {
  width: 100%;
  height: 200px;
}

.pc-login-title {
  margin: 0 0 28px;
  color: #333;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
}

/* 登录方式 Tab 切换 */
.topTabSelect {
  margin-bottom: 0;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
  color: #333;
  font-size: 14px;
  text-align: center;
  cursor: pointer;

  .flex-1 {
    position: relative;

    &.active {
      color: #28b8c3;

      &::after {
        position: absolute;
        bottom: -10px;
        left: 0;
        display: block;
        width: 100%;
        height: 2px;
        background-color: #28b8c3;
        content: "";
      }
    }
  }
}

/* 账号/手机号登录表单公共样式 */
:deep(.el-form-item__error) {
  padding-top: 0;
}

.userlogin {
  .el-form-item {
    margin-bottom: 22px;
  }
}

.login-form {
  width: 100%;
  margin: 16px 0 10px;

  i {
    color: #333;
  }

  :deep(.el-form-item__content) {
    width: 100%;
  }

  :deep(.el-input) {
    input {
      color: #333;
      text-indent: 5px;
    }

    .el-input__prefix {
      i {
        padding: 0 5px;
        font-size: 16px !important;
      }
    }
  }

  .row {
    display: flex;
    align-items: center;
    gap: 10px;

    :deep(.el-input) {
      flex: 1;
    }
  }
}

.mt16 {
  margin-top: 16px;
}

.login-code {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 0 0 10px;
}

.login-code-img {
  width: 100px;
  height: 34px;
  margin-top: 2px;
  border: 1px solid #f0f0f0;
  background-color: #fdfdfd;
  color: #333;
  font-size: 14px;

  line-height: 34px;
  letter-spacing: 5px;
  text-align: center;
  text-indent: 5px;
  cursor: pointer !important;
}

.send-code-btn {
  flex-shrink: 0;
  min-width: 100px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #28b8c3;
  border-radius: 4px;
  background-color: #fff;
  color: #28b8c3;
  font-size: 13px;
  cursor: pointer;

  &:hover,
  &:focus {
    border-color: #28b8c3;
    background-color: #f0fbfc;
    color: #28b8c3;
  }

  &.is-disabled {
    border-color: #dcdfe6;
    background-color: #f5f7fa;
    color: #c0c4cc;
    cursor: not-allowed;
  }
}

.login-submit {
  flex-shrink: 0;
  width: 100%;
  height: 44px;
  margin-top: 15px;
  margin-bottom: 5px;
  font-size: 16px;
  letter-spacing: 5px;
  cursor: pointer;
}

:deep(.el-input__icon) {
  margin-left: 5px;
  cursor: pointer;
}
</style>
